module.exports = __webpack_public_path__ + "static/media/teams-icon.6ba739fe.svg";